import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../../../common/SharedComponents';
import { LoanPageType, LoanStatusType } from '../../../../../loans/common/LoanConstants';
import LoansLandingPageGeneric from '../../../../../loans/LoansLandingPageGeneric';
import { LoansWorkspacePage } from '../../../../../loans/LoansWorkspacePage/LoansWorkspacePage';

export default function LoansLostRoutes() {
    return (
        <>
            <Route
                path='/loans/lost/loc'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.LOC}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/construction'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Construction}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/rental'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Rental}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/buildrent'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.BuildRent}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/fixflip'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.FixFlip}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/land'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Land}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/model'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Model}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost/bridge'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Bridge}
                            statusId={LoanStatusType.Lost}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/lost'
                element={
                    <RequireAdmin>
                        <LoansWorkspacePage status={LoanStatusType.Lost} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
